









import { Vue, Component, Prop } from "vue-property-decorator";
import Header from "@/components/header/index.vue";
import Footer from "@/components/footer/index.vue";
import Login from "./login.vue";
import ForgetPwd from "./forgetPwd.vue";
import Register from "./register.vue";
import Agreement from "./agreement.vue";
import { RouteToComponent } from "./interface";
import Img from "@/assets/images/100banner-new.jpg";
import PersonCenter from "./personCenter.vue";
@Component({
  components: {
    Header,
    Footer,
    Login,
    ForgetPwd,
    Register,
    Agreement,
    PersonCenter
  }
})
export default class LoginWrap extends Vue {
  img = Img;
  get currentComponent(): any {
    const { path } = this.$route;
    const routeToComponent: RouteToComponent = {
      "/login": Login,
      "/forgetPwd": ForgetPwd,
      "/register": Register,
      "/agreement": Agreement,
      "/person-center": PersonCenter
    };
    return routeToComponent[path];
    // return
  }
}
